





















export default {
	name: 'login',
	inject: ['responsive'],
	// components: {
	// 	Session,
	// 	ElCard,
	// },
	data() {
		return {
			publicPath: process.env.BASE_URL,
		};
	},
	computed: {},
	methods: {},
	mounted() {},
};
